import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import PortModel from '../models/PortModel';
import AreaModel from '../models/AreaModel';
import AreaBookmarkInputModel from '../models/AreaBookmarkInputModel';

interface portSelectorState {
    ports: PortModel[],
    areas: AreaModel[],
    masterAreas: string[],
    triggerRefreshTable: number,
    openBookmarkModel: boolean,
    bookmarkInput: AreaBookmarkInputModel
}

export const initialState: portSelectorState = {
    ports: [],
    areas: [],
    masterAreas: [],
    triggerRefreshTable: 0,
    openBookmarkModel: false,
    bookmarkInput: {
        id: 0,
        name: "",
        areas: [],
        isUpdate: false
    } as AreaBookmarkInputModel
}

export const PortSelectorSlice = createSlice({
    name: "PortSelector",
    initialState,
    reducers: {
        setPorts: (state, action: PayloadAction<PortModel[]>) => {
            state.ports = action.payload;
        },
        setAreas: (state, action: PayloadAction<AreaModel[]>) => {
            state.areas = action.payload;
        },
        setMasterAreas: (state, action: PayloadAction<string[]>) => {
            state.masterAreas = action.payload;
        },
        setTriggerRefreshTable: (state, action: PayloadAction<number>) => {
            state.triggerRefreshTable = action.payload;
        },
        setOpenModal: (state, action: PayloadAction<boolean>) => {
            state.openBookmarkModel = action.payload;
        },
        setBookmarkInputName: (state, action: PayloadAction<string>) => {
            state.bookmarkInput.name = action.payload;
        },
        setBookmarkInputAreas: (state, action: PayloadAction<AreaModel[]>) => {
            state.bookmarkInput.areas = action.payload;
        },
        setBookmarkInput: (state, action: PayloadAction<AreaBookmarkInputModel>) => {
            state.bookmarkInput = action.payload;
        },
        resetBookmarkInput: (state) => {
            state.bookmarkInput = {
                id: 0,
                name: "",
                areas: [],
                isUpdate: false
            } as AreaBookmarkInputModel;
        },
    }
});

export const portSelectorSelector = createSelector(
    (state: RootState) => state.portSelector,
    (data) => data
);

export const {
    setPorts,
    setAreas,
    setMasterAreas,
    setTriggerRefreshTable,
    setOpenModal,
    setBookmarkInputName,
    setBookmarkInputAreas,
    resetBookmarkInput,
    setBookmarkInput
} = PortSelectorSlice.actions;

export default PortSelectorSlice.reducer;